"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var storeApi = _interopRequireWildcard(require("@/api/product.js"));
var _info = _interopRequireDefault(require("./info"));
var _edit = _interopRequireDefault(require("./edit"));
var selfUtil = _interopRequireWildcard(require("@/utils/ZBKJIutil.js"));
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  // name: "list"
  components: {
    info: _info.default,
    edit: _edit.default
  },
  props: {
    biztype: {
      // 类型，1 产品分类，2 附件分类，3 文章分类， 4 设置分类， 5 菜单分类
      type: Object,
      default: {
        value: -1
      },
      validator: function validator(obj) {
        return obj.value > 0;
      }
    },
    pid: {
      type: Number,
      default: 0,
      validator: function validator(value) {
        return value >= 0;
      }
    },
    selectModel: {
      // 是否选择模式
      type: Boolean,
      default: false
    },
    selectModelKeys: {
      type: Array
    },
    rowSelect: {}
  },
  data: function data() {
    return {
      listLoading: false,
      selectModelKeysNew: this.selectModelKeys,
      loading: false,
      constants: this.$constants,
      treeProps: {
        label: 'name',
        children: 'child'
      },
      multipleSelection: [],
      editDialogConfig: {
        visible: false,
        isCreate: 0,
        // 0=创建，1=编辑
        prent: {},
        // 父级对象
        data: {},
        biztype: this.biztype // 统一主业务中的目录类型
      },
      dataList: [],
      treeList: [],
      listPram: {
        pid: this.pid,
        type: this.biztype.value,
        isShow: false,
        name: '',
        page: this.$constants.page.page,
        limit: this.$constants.page.limit[0]
      },
      viewInfoConfig: {
        data: null,
        visible: false
      },
      defaultImg: require('@/assets/imgs/moren.jpg')
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['merchant:product:category:list'])) this.handlerGetTreeList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    //权限控制
    onchangeIsShow: function onchangeIsShow(row) {
      var _this = this;
      storeApi.productCategoryShowApi(row.id).then(function () {
        _this.$message.success('修改成功');
        _this.handlerGetTreeList();
        _this.$store.commit('product/SET_MerProductClassify', []);
      });
    },
    handleEditMenu: function handleEditMenu(rowData) {
      this.editDialogConfig.isCreate = 1;
      this.editDialogConfig.data = rowData;
      this.editDialogConfig.prent = rowData;
      this.editDialogConfig.visible = true;
    },
    handleAddMenu: function handleAddMenu(rowData) {
      this.editDialogConfig.isCreate = 0;
      this.editDialogConfig.prent = rowData;
      this.editDialogConfig.data = {};
      this.editDialogConfig.biztype = this.biztype;
      this.editDialogConfig.visible = true;
    },
    getCurrentNode: function getCurrentNode(data) {
      var node = this.$refs.tree.getNode(data);
      this.childNodes(node);
      //编辑时候使用
      this.$emit('rulesSelect', this.$refs.tree.getCheckedKeys());
    },
    //具体方法可以看element官网api
    childNodes: function childNodes(node) {
      var len = node.childNodes.length;
      for (var i = 0; i < len; i++) {
        node.childNodes[i].checked = node.checked;
        this.childNodes(node.childNodes[i]);
      }
    },
    parentNodes: function parentNodes(node) {
      if (node.parent) {
        for (var key in node) {
          if (key == 'parent') {
            node[key].checked = true;
            this.parentNodes(node[key]);
          }
        }
      }
    },
    handleDelMenu: function handleDelMenu(rowData) {
      var _this2 = this;
      this.$modalSure('删除当前数据?').then(function () {
        storeApi.productCategoryDeleteApi(rowData.id).then(function (res) {
          _this2.handlerGetTreeList();
          _this2.$store.commit('product/SET_MerProductClassify', []);
          _this2.$message.success('删除成功');
        });
      });
    },
    handlerGetList: function handlerGetList() {
      this.handlerGetTreeList();
    },
    changeNodes: function changeNodes(data) {
      if (data.length > 0) {
        for (var i = 0; i < data.length; i++) {
          if (!data[i].childList || data[i].childList.length < 1) {
            data[i].childList = undefined;
          } else {
            this.changeNodes(data[i].childList);
          }
        }
      }
      return data;
    },
    handlerGetTreeList: function handlerGetTreeList() {
      var _this3 = this;
      storeApi.productCategoryListApi().then(function (res) {
        var obj = {},
          dataList = [];
        res.forEach(function (item) {
          obj = item;
          obj.parentId = item.pid;
          obj.children = [];
          dataList.push(obj);
        });
        _this3.dataList = _this3.handleTree(dataList, 'menuId');
        _this3.treeList = _this3.handleAddArrt(res);
        _this3.loading = false;
      }).catch(function () {
        _this3.loading = false;
      });
    },
    handlerGetInfo: function handlerGetInfo(id) {
      this.viewInfoConfig.data = id;
      this.viewInfoConfig.visible = true;
    },
    handleNodeClick: function handleNodeClick(data) {
      console.log('data:', data);
    },
    handleAddArrt: function handleAddArrt(treeData) {
      var _result = selfUtil.addTreeListLabel(treeData);
      return _result;
    },
    hideEditDialog: function hideEditDialog() {
      var _this4 = this;
      setTimeout(function () {
        _this4.editDialogConfig.prent = {};
        _this4.editDialogConfig.type = 0;
        _this4.editDialogConfig.visible = false;
        _this4.handlerGetTreeList();
      }, 200);
    },
    handleSelectionChange: function handleSelectionChange(d1, _ref) {
      var checkedNodes = _ref.checkedNodes,
        checkedKeys = _ref.checkedKeys,
        halfCheckedNodes = _ref.halfCheckedNodes,
        halfCheckedKeys = _ref.halfCheckedKeys;
      // this.multipleSelection =  checkedKeys.concat(halfCheckedKeys)
      this.multipleSelection = checkedKeys;
      this.$emit('rulesSelect', this.multipleSelection);
    }
  }
};